import * as angular from 'angular';
export var UI_ROUTER_REACT_HYBRID = 'ui.router.react.hybrid';
export var hybridModule = angular.module(UI_ROUTER_REACT_HYBRID, ['ui.router']);
export default UI_ROUTER_REACT_HYBRID;
//# sourceMappingURL=module.js.map